<template>
  <div>
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> AV Verträge </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">AV Verträge</li>
              </ul>
            </div>
          </div>

          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-2">
                <div class="dropdown">
                  <a class="dropdown-toggle recently-viewed" href="#" role="button" data-toggle="dropdown" aria-expanded="false"> Alle geprüfte Verträge</a>
                  <div class="dropdown-menu">
                    <a class="dropdown-item" href="#">Offen</a>
                    <a class="dropdown-item" href="#">Prio A</a>
                    <a class="dropdown-item" href="#">Prio B</a>
                    <a class="dropdown-item" href="#">Prio C</a>
                    <a class="dropdown-item" href="#">Prio D</a>
                  </div>
                </div>
              </div>
              <div class="col-10 text-right">
                <ul class="list-inline-item pl-0">
                  <li class="list-inline-item">
                    <a href="#" @click.prevent="refreshList" id="dark-mode-toggle">
                      <i class="fa fa-refresh" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <div class="dropdown">
                      <a class="dropdown-toggle recently-viewed" href="#" role="button" data-toggle="dropdown" aria-expanded="false">Spalte anzeigen</a>
                      <div class="dropdown-menu">
                        <a v-for="(column, index) in columns" class="dropdown-item dropdown-column-item" href="#" @click.prevent="toggle_column($event,index)"><i class="fa fa-check"></i> {{column}}</a>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item dropdown list-inline-item add-lists">
                    <a class="nav-link dropdown-toggle" id="profileDropdown" href="#" data-toggle="dropdown" aria-expanded="false">
                      <div class="nav-profile-text">
                        <i class="fa fa-th" aria-hidden="true"></i>
                      </div>
                    </a>
                    <div class="dropdown-menu navbar-dropdown" aria-labelledby="profileDropdown">

                      <router-link class="dropdown-item" to="/gap-list">Liste Ansicht</router-link>
                      <router-link class="dropdown-item" to="/gap-survey">Fragebogen Ansicht</router-link>
                    </div>
                  </li>
                  <li class="list-inline-item">
                    <button class="add btn btn-gradient-primary font-weight-bold text-white todo-list-add-btn btn-rounded" id="add_gap_question" data-toggle="modal" data-target="#add_gap_question_modal">Neue Frage</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Content Starts -->
          <div class="row">
            <div class="col-md-12">
              <div class="card mb-0">
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-striped table-nowrap custom-table mb-0 datatable">
                      <thead>
                      <tr>
                        <th v-for="column in columns">{{column}}</th>
                        <th class="text-right">Actions</th>
                      </tr>
                      <tr class="filters">
                        <th v-for="column in columns"><input type="text" class="form-control input-sm" style="height: 30px !important;"></th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DDKModal
            title="Prüfübersicht"
            v-if="showConfirm"
            width="50%"
            @close ="showConfirm = false"
            :before-close="handleClose">
            <h4 slot="header">Prüfbericht: DDK - {{ account.name }} - {{ reportDate }}</h4>
            <div slot="body">
              <div>
                <h5>Übersicht</h5>
                <table class="overview-table">
                    <tr>
                      <th class="overview-cell"></th>
                      <th class="overview-cell">Kategorie</th>
                      <th class="overview-cell">Bemerkungen</th>
                    </tr>
                    <tr v-for="(overviewValue) in organizedResult" :key="overviewValue.id">
                      <th class="overview-cell" :class="overviewValue.result=== 'passed' ? 'igreen' : 'ired'">
                        {{overviewValue.result}}
                      </th>
                      <td class="overview-cell">{{overviewValue.title}}</td>
                      <td class="overview-cell">{{overviewValue.comment}}</td>
                    </tr>
                  </table>
              </div>
              <div v-for="(value, key, index) in organizedResult">
                <div class="row" style="margin: 5px">
                  <h5 class="dialogtitle">{{index}}. {{value.title}} </h5>
                </div>
                <table class="overview-table">
                  <tr>
                    <th class="overview-cell"></th>
                    <th class="overview-cell">Frage</th>
                    <th class="overview-cell">Antwort</th>
                    <th class="overview-cell">Bemerkungen</th>
                  </tr>
                  <tr v-for="(item, itemIndex) in value['content']" :key="itemIndex">
                    <th class="overview-cell" :class="item.result=== 'passed' ? 'igreen' : 'ired'">
                          {{item.result}}
                    </th>
                    <th class="overview-cell">
                        <span>
                          <p>{{ item.question }}</p>
                        </span>
                    </th>
                    <th class="overview-cell">
                        <span>
                          <p>{{ item.answer }}</p>
                        </span>
                    </th>
                    <th class="overview-cell">
                        <span>
                          <p>{{ item.comment }}</p>
                        </span>
                    </th>
                  </tr>
                </table>
                <div><br></div>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button class="btn btn-secondary btn-sm" @click="showConfirm=false">schließen</button>
              </span>
          </DDKModal>
          <!-- /Content End -->

        </div>
        <!-- /Page Content -->

      </div>
      <!-- /Page Wrapper -->
    </div>

  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import "survey-vue/defaultV2.css";
  import service from '@/utils/request.js';
  import { baseURL, pathSeparator } from '@/utils/request'
  import DDKModal from '@/components/component/Modal';
  export default {
    components: {DDKModal},
    data() {
      return {
        showConfirm: false,
        organizedResult: {},
        av_list:[],
        columns: [
          'Vertrag',
          'Partner',
          'Prüfbericht',
          'Status',
          'Verträge',
          'Geprüft am',
        ]
      }
    },
    created() {
      this.getAVs()
    },
    computed: {...mapState({accountid: state => state.account.accountid, userName: state => state.user.username, account: state => state.account, userID: state => state.user.id}), },
    mounted() {

      // Select 2

      if ($('.select').length > 0) {
        $('.select').select2({
          minimumResultsForSearch: -1,
          width: '100%'
        });
      }

    },
    updated ()
    {

      // Date Time Picker

      if ($('.datetimepicker').length > 0) {
        $('.datetimepicker').datetimepicker({
          format: 'DD/MM/YYYY',
          icons: {
            up: "fa fa-angle-up",
            down: "fa fa-angle-down",
            next: 'fa fa-angle-right',
            previous: 'fa fa-angle-left'
          }
        });
      }

      // Datatable

      if ($('.datatable').length === 0) {
        $('.datatable').DataTable({
          "bFilter": false,
          retrieve: true,
        });
      }

      // call question modal
      $('.q-old-internal-number').on('click', function(e) {
        e.preventDefault();
        let question_id = $(this).data('question-id')
        this.show_question_survey(question_id);
      })
    },
    methods: {
      toggle_column(event, column_index) {
        // Get the column API object
        let column = $('.datatable').DataTable().column(column_index);

        // Toggle the visibility
        column.visible(!column.visible());

        // adjust dropdown menu
        if (column.visible() && !$(event.target).hasClass('selected')) {
          $(event.target).addClass('selected')
        } else if (!column.visible() && $(event.target).hasClass('selected')) {
          $(event.target).removeClass('selected');
        }
      },
      close_help() {
        $('#modal-help').hide()
      },
      refreshList() {
        service.request({
          url: `survey/v1/av/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then((response) => {
          this.av_list = response.data;
          this.table.clear().rows.add(this.av_list).draw(false)
        })
      },
      async getAVs() {
        const that = this
        service.request({
          url: `survey/v1/av/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then(function(response) {
          that.av_list = response.data;
          that.table = $('.datatable').DataTable({
            "data": that.av_list,
            "oLanguage": {
              "oPaginate": { "sPrevious": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>', "sNext": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>' },
              "sInfo": "Seite _PAGE_ von _PAGES_",
              "sSearch": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>',
              "sSearchPlaceholder": "Suche...",
              "sLengthMenu": "Einträge per Seite:  _MENU_",
            },
            responsive: true,
            "lengthMenu": [10, 20, 50],
            "pageLength": 10,
            drawCallback: function () {
              $('.t-dot').tooltip({ template: '<div class="tooltip status" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>' })
              $('.av-overview').on('click', (e) => {
                e.preventDefault()
                const surveyID = $(e.target).data('survey-id')
                that.organizedResult = that.av_list.filter(item => item.id === surveyID)[0].sorted_result.organizedResult
                that.showConfirm = true
              })
              $('.delete-result').on('click', (e) => {
                e.preventDefault()
                const checkID = $(e.target).data('check-id')
                const objectIndex = that.av_list.map(e=>e.id).indexOf(checkID)
                that.$confirm(
                  {
                    message: `Sicher, dass diese AV Prüfung gelöscht wird?`,
                    button: {
                      no: 'Nein',
                      yes: 'Ja'
                    },
                    callback: confirm => {
                      if (confirm) {
                        service.request({
                          url: `survey/v1/delete_av/${checkID}/`,
                          method: 'DELETE',
                          responseType: 'json'
                        }).then(function(res) {
                          if (objectIndex > -1) {
                            that.av_list.splice(objectIndex, 1)
                            $('.datatable').DataTable().clear().rows.add(that.av_list).draw()
                          }
                          that.$vToastify.success(`die AV Prüfung ist erfolgreich gelöscht!`)
                        })
                      }
                    }
                  }
                )
              })
              $('.edit-result').on('click', (e) => {
                e.preventDefault()
                const checkID = $(e.target).data('check-id')
                const checkItem = that.av_list.filter(item => item.id === parseInt(checkID))[0]
                service.request({
                  url: `survey/v1/survey/${checkItem.survey}/`,
                  method: 'GET',
                  responseType: 'json'
                }).then(function(response) {
                  const filenameArray = checkItem.unquoted_report_url.split('\\')
                  that.$router.push({name: 'avv-content', params: {
                      surveyID: checkItem.survey,
                      surveyJson: response.data.body,
                      partnerName: checkItem.partner_name,
                      partnerAddress: checkItem.partner_address,
                      contractName: checkItem.contract_name,
                      gapInput: checkItem.question ? true : false,
                      filename: filenameArray[filenameArray.length-1],
                      auftragsgeber: checkItem.controller_name,
                      remarks: checkItem.remarks,
                      partnerID: checkItem.partner,
                      surveyResult: JSON.parse(checkItem.result_body),
                      resultObject: checkItem,
                      statusSign: checkItem.without_sign
                    }})
                }).catch(function(err) {
                  console.log(err)
                })
              })
            },
            fixedHeader: true,
            initComplete: function () {
              var api = this.api();

              // For each column
              api
                .columns()
                .eq(0)
                .each(function (colIdx) {
                  // Set the header cell to contain the input element
                  var cell = $('.filters th').eq(
                    $(api.column(colIdx).header()).index()
                  );

                  // On every keypress in this input
                  $(
                    'input',
                    $('.filters th').eq($(api.column(colIdx).header()).index())
                  )
                    .off('keyup change')
                    .on('keyup change', function (e) {
                      e.stopPropagation();

                      // Get the search value
                      $(this).attr('title', $(this).val());
                      var regexr = '({search})'; //$(this).parents('th').find('select').val();

                      var cursorPosition = this.selectionStart;
                      // Search the column for that value
                      api
                        .column(colIdx)
                        .search(
                          this.value != ''
                            ? regexr.replace('{search}', '(((' + this.value + ')))')
                            : '',
                          this.value != '',
                          this.value == ''
                        )
                        .draw();

                      $(this)
                        .focus()[0]
                        .setSelectionRange(cursorPosition, cursorPosition);
                    });
                });

              $('.dropdown-menu a.dropdown-column-item').each(function(index, item) {
                if (api.column(index).visible() && !$(item).hasClass('selected')) {
                  $(item).addClass('selected')
                } else if (!api.column(index).visible() && $(item).hasClass('selected')) {
                  $(item).removeClass('selected');
                }
              })
            },
            "columns": [
              { data: "contract_name", width: "15%" },
              { data: "partner_name", width: "15%" },
              { data: "unquoted_report_url", render: (data) => `<a download href="${baseURL}/survey/v1/download/?filename=${encodeURIComponent(data)}" target="_blank">${data.split(pathSeparator).at(-1)}</a>`, width: "20%" },
              { data: "status", width: "10%" },
              { data: "attachments", render: (data) => {
                let return_html = ''
                data.forEach(item => return_html += `<a download href="${baseURL}/survey/v1/download/?filename=${encodeURIComponent(item)}" target="_blank">${item.split("/").at(-1)}</a>`)
                return return_html
                }, width: "20%" },
              { data: "createdon", width: "10%", render: (data) => typeof data === 'string' ? data.substring(0, 10) : '' },
              { data: null, render: function(data) {
                  var return_html = `
                  <div class="dropdown dropdown-action">
                      <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i class="material-icons">more_vert</i></a>
                      <div class="dropdown-menu dropdown-menu-right">
                          <a class="dropdown-item edit-result" href="#" data-check-id="${data.id}">Prüfergebnis bearbeiten</a>
                          <a class="dropdown-item delete-result" href="#" data-check-id="${data.id}">Prüfergebnis löschen</a>
                          <a class="dropdown-item add-customer" href="#" data-survey-id="${data.id}">Partner als Auftraggeber aufnehmen</a>
                          <a class="dropdown-item add-supplier" href="#" data-survey-id="${data.id}">Partner als Auftragnehmer aufnehmen</a>
                      </div>
                  </div>
                  `;
                  return return_html
                }, width: "5%" }
            ],
            order: [[5, 'desc']],
            columnDefs: [
              { width: "150px", targets: 2 },
              {className: "text-wrap", targets: "_all"},
            ],
            buttons: [
              'csv', 'excel', 'pdf'
            ],
            dom: 'Bfrtip',
            retrieve: true,
          });
        }).catch(function(err) {
          console.log(err)
        })
      },
    }
  }
</script>

<style scoped>
  .overview-table {
    font-family: 'Tahoma', arial, sans-serif;
    border-collapse: collapse;
    border: 1px solid;
    width: 100%;
  }

  .overview-cell {
    text-align: center;
    padding: 8px;
    vertical-align: middle;
    box-sizing: content-box;
    border: 1px solid;
    color: #1f1f1f;
  }
  .ired {
    background-color: red
  }
  .igreen {
    background-color: green
  }
</style>
